/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import VacancyPublicationForm from 'domain/recruiting/vacancy/publication/createupdate/VacancyPublicationForm';
import useVacancyPublicationService from 'domain/recruiting/vacancy/publication/shared/vacancyPublicationService';
import CreateVacancyPublicationBreadcrumbs from 'domain/recruiting/vacancy/publication/createupdate/Create/Breadcrumbs';
import { useVacancyPublicationUrl } from 'domain/recruiting/vacancy/publication/vacancyPublicationRoute';

const CreateVacancyPublication = () => {
  const { createVacancy, getValidationSchema } = useVacancyPublicationService();
  const { getListUrl } = useVacancyPublicationUrl();

  return (
    <CreateForm
      submitFormFunc={createVacancy}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Vacancy Publication has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Vacancy Publication" breadcrumbs={<CreateVacancyPublicationBreadcrumbs />}>
        <VacancyPublicationForm isCreateForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateVacancyPublication;
